import React, { useEffect } from "react"

import { Button, Checkbox, Dropdown, Flex, Typography } from "antd"

import Icon from "../../Icon"

import "./MultipleSelect.less"

const { Text } = Typography

const MultipleSelect = ({
  values = [],
  onChange,
  options = [],
  allBtnText = "All",
  mixedValuesText = "Mixed values",
  oneSelectedText = "",
  className = "",
  loading = false
}) => {
  const [isSelectedAll, setIsSelectedAll] = React.useState(false)

  const handleCheckboxChange = (checkedValue) => {
    if ((values.length === options.length || values.length === 0) && options?.length > 1) {
      onChange([checkedValue])
      return
    }
    const newValues = values.includes(checkedValue)
      ? values.filter((v) => v !== checkedValue)
      : [...values, checkedValue]
    onChange(newValues)
  }

  const selectAllHandler = (isSelectedAll) => {
    if (isSelectedAll) {
      onChange(options.map((opt) => opt.value))
    } else {
      onChange([])
    }
    setIsSelectedAll(isSelectedAll)
  }

  const getSelectText = () => {
    if (values.length === options.length) return allBtnText
    if (values.length === 0) return allBtnText
    if (values.length === 1) {
      const selectedOption = options.find((opt) => opt.value === values[0])
      return selectedOption ? oneSelectedText + selectedOption.label : oneSelectedText
    }
    return mixedValuesText
  }

  useEffect(() => {
    if (values.length !== options.length) {
      setIsSelectedAll(false)
    } else {
      setIsSelectedAll(true)
    }
  }, [values, options])

  return (
    <Dropdown
      dropdownRender={() => (
        <Flex className="dropdown-content" gap={8} vertical>
          {options.length > 1 && (
            <Checkbox checked={isSelectedAll} onChange={(e) => selectAllHandler(e.target.checked)}>
              <Text>{allBtnText}</Text>
            </Checkbox>
          )}
          {options.map((option) => (
            <Checkbox
              key={option.value}
              checked={values.includes(option.value)}
              onChange={() => handleCheckboxChange(option.value)}
            >
              {option.label}
            </Checkbox>
          ))}
        </Flex>
      )}
      trigger={loading ? [] : ["click"]}
      rootClassName="multiple-select-dropdown"
      className={`multiple-select-trigger ${className}`.trim()}
      getPopupContainer={() => document.getElementById("main-layout")}
    >
      <Button
        className="multiple-select-button"
        size="middle"
        style={{ height: "36px", justifyContent: "space-between" }}
        loading={loading}
        disabled={loading}
      >
        <Text className="multiple-select-button-text" ellipsis>
          {getSelectText()}
        </Text>
        <Icon type="chevron_down" style={{ marginLeft: "auto" }} />
      </Button>
    </Dropdown>
  )
}

export default MultipleSelect
